<!--
component: SearchAttr
author: Ken Nakamura
description: 属性（詳細）検索画面
-->
<template>
  <section class="search-attr">
    <v-container fluid class="pa-0">
      <div class="head-message mb-1">{{ headMessage }}</div>
      <v-row justify="center" class="my-1">
        <v-col cols="11" class="pt-1 px-0">
          <v-card>
            <v-card-title class="py-1">
              検索対象からはずすには、項目名（<v-icon>mdi-checkbox-outline</v-icon>）を押して切り替えて下さい。
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="ma-1 py-2 justify-center">
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-item-group
                  v-model="selected"
                  multiple
                >
                  <!-- 申請種別（必須）項目,申請区分（必須）項目 -->
                  <v-row>
                    <v-col class="py-0">
                      <v-row align="center" class="ma-1"> 
                        <v-col cols="12" sm="12" md="5" lg="4" class="text-left item-name py-1">
                          申請種別（必須）
                        </v-col>
                        <v-col class="py-1" cols="12" sm="12" md="7" lg="8">
                          <v-btn-toggle v-model="snsShubetsu" mandatory background-color="white" dense>
                            <v-btn active-class="light-blue darken-3 white--text" tabindex="0" id="kenchiku">建築物</v-btn>
                            <v-btn active-class="light-blue darken-3 white--text" tabindex="1">工作物</v-btn>
                          </v-btn-toggle>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-divider vertical class="my-2"></v-divider>
                    <v-col class="py-0">
                      <v-row class="ma-1" align="center">
                        <v-col cols="12" sm="12" md="5" lg="4" class="text-left item-name py-1">
                          申請区分（必須）
                        </v-col>
                        <v-col class="py-1" cols="12" sm="12" md="7" lg="8">
                          <v-btn-toggle v-model="snsKubun" multiple mandatory background-color="white" dense>
                            <v-btn active-class="light-blue darken-3 white--text" tabindex="2">確認申請</v-btn>
                            <v-btn active-class="light-blue darken-3 white--text" tabindex="3">変更申請</v-btn>
                          </v-btn-toggle>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-divider class="my-2"></v-divider>
                  <!-- 一般計画（必須）項目 -->
                  <v-row>
                    <v-col class="py-0">
                      <v-row class="ma-1" align="center">
                        <v-col cols="12" sm="12" md="5" lg="4" class="text-left item-name py-1">
                          一般計画（必須）
                        </v-col>
                        <v-col class="py-1" cols="12" sm="12" md="7" lg="8">
                          <v-btn-toggle v-model="ippanKeikaku" multiple mandatory color="blue" dense>
                            <v-btn active-class="light-blue darken-3 white--text" tabindex="4">一般</v-btn>
                            <v-btn active-class="light-blue darken-3 white--text" tabindex="5">計画通知</v-btn>
                          </v-btn-toggle>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col></v-col>
                  </v-row>
                  <v-divider class="my-2"></v-divider>
                  <!-- 受付年度、番号 項目 -->
                  <v-row class="py-0">
                    <v-col cols="12" class="py-0 pr-lg-0 pr-md-0" sm="12" md="6" lg="6">
                      <v-item v-slot="{ active, toggle }">
                        <v-row class="ma-1" align="center" :class="!active ? '': 'grey lighten-1'">
                          <v-col>
                            <v-row align="center">
                              <v-col
                                cols="12"
                                sm="4" md="4" lg="4"
                                id="rcpFiscalYear" class="text-left item-name"
                                @click="toggle" @keydown.space="toggle"
                                tabindex=6>
                                <v-row align="center">
                                  <v-col cols="2" align="center"><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon></v-col>
                                  <v-col cols="10" align="left"><span>受付年度</span></v-col>
                                </v-row>
                              </v-col>
                              <v-col>
                                <v-row class="py-0">
                                  <v-col cols="12" sm="6" md="6" lg="6" align-self="center" class="py-1">
                                    <v-select
                                      :items="eraList"
                                      :background-color="!active ? '': 'grey lighten-1'"
                                      item-text="era"
                                      @change="rcpYearSelected()"
                                      v-model="rcpYearEra"
                                      hide-details
                                      solo dense
                                      placeholder="元号"
                                      :tabindex="selected.indexOf(0) == -1 ? 7 : -1"
                                    ></v-select>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="6" lg="6" class="py-1">
                                    <v-combobox
                                      :items="rcpYearItems"
                                      :background-color="!active ? '': 'grey lighten-1'"
                                      item-text="fiscalYear"
                                      v-model="rcpYearYear"
                                      solo dense
                                      no-data-text="選択可能なデータはありません。"
                                      hide-details
                                      placeholder="年度"
                                      :tabindex="selected.indexOf(0) == -1 ? 8 : -1"
                                    ></v-combobox>
                                  </v-col>
                                </v-row>
                                <v-alert dence text type="error" v-show="rcpYearErrMsg" class="pa-1 mt-3 mb-0">{{ rcpYearErrMsg }}</v-alert>
                                <v-alert :class="selected.indexOf(0) == -1 ? 'white' : 'grey lighten-1'" class="mt-3 mb-0" v-show="!rcpYearErrMsg && rcpNo1ErrMsg"></v-alert>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-item>
                    </v-col>
                    <v-divider vertical class="my-1" v-show="['md','lg'].includes($vuetify.breakpoint.name)"></v-divider>
                    <v-col cols="12" class="py-0 pl-lg-0 pl-md-0" sm="12" md="6" lg="6">
                      <v-item v-slot="{ active, toggle }">
                        <v-row class="ma-1" align="center" :class="!active ? '': 'grey lighten-1'">
                          <v-col
                            cols="12"
                            sm="4" md="4" lg="3"
                            id="rcpNo1" class="pa-2 text-left item-name"
                            @click="toggle" @keydown.space="toggle"
                            tabindex=9>
                            <v-row align="center">
                              <v-col cols="2" align="center"><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon></v-col>
                              <v-col cols="10" align="left"><span>番号</span></v-col>
                            </v-row>
                            <!-- <span><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon> 番号</span> -->
                          </v-col>
                          <v-col>
                            <v-row>
                              <v-col class="py-1">
                                <v-text-field
                                  id="rcpNum"
                                  ref="rcpNum"
                                  type="tel"
                                  autocomplete="nope"
                                  placeholder="1~99999で入力してください。"
                                  v-model="rcpNo1Com"
                                  outlined
                                  hide-details
                                  hide-spin-buttons
                                  min="1"
                                  max="99999"
                                  dense
                                  :tabindex="selected.indexOf(1) == -1 ? 10 : -1"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-alert dence text type="error" v-show="rcpNo1ErrMsg" class="pa-1 mt-3 mb-0">{{ rcpNo1ErrMsg }}</v-alert>
                            <v-alert :class="selected.indexOf(1) == -1 ? 'white' : 'grey lighten-1'" class="mt-3 mb-0" v-show="rcpYearErrMsg && !rcpNo1ErrMsg"></v-alert>
                          </v-col>
                        </v-row>
                      </v-item>
                    </v-col>
                  </v-row>
                  <v-divider class="my-2"></v-divider>
                  <!-- 受付年月日 -->
                  <v-row class="py-0">
                    <v-col class="py-0">
                      <v-item v-slot="{ active, toggle }">
                        <v-row class="ma-1" :class="!active ? '': 'grey lighten-1'">
                          <v-col>
                            <v-row align="center" class="py-0">
                              <v-col
                                cols="12"
                                sm="4" md="2" lg="2"
                                id="rcpYear" class="text-left item-name"
                                @click="toggle" @keydown.space="toggle"
                                tabindex=11>
                                <v-row align="center">
                                  <v-col cols="2" xs="1" sm="2" md="2" lg="2" align="center"><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon></v-col>
                                  <v-col cols="10" align="left"><span>受付年月日</span></v-col>
                                </v-row>
                              </v-col>
                              <v-col class="py-0">
                                <v-row align="center" class="ma-1">
                                  <v-col cols="12" sm="5" md="5" lg="5" class="py-0 pl-0">
                                    <DatePicker
                                      ref="rcpStartDate" v-model="rcpStart" @clear="rcpStart = $event"
                                      :tabIdx="selected.indexOf(2) == -1 ? 12 : -2" :active="active"/>
                                  </v-col>
                                  <v-col cols="12" sm="2" md="1" lg="1" class="text-center py-2 pl-0" justify="center">～</v-col>
                                  <v-col cols="12" sm="5" md="5" lg="5" class="py-0 pl-0">
                                    <DatePicker
                                      ref="rcpEndDate" v-model="rcpEnd" @clear="rcpEnd = $event"
                                      :tabIdx="selected.indexOf(2) == -1 ? 13 : -2" :active="active"/>
                                  </v-col>
                                </v-row>
                                <v-alert dence text type="error" v-show="rcpDateErrMsg" class="pa-1 mt-1 mb-0">{{ rcpDateErrMsg }}</v-alert>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-item>
                    </v-col>
                  </v-row>
                  <v-divider class="my-2"></v-divider>
                  <!-- 受付番号 -->
                  <v-row>
                    <v-col class="py-0">
                      <v-item v-slot="{ active, toggle }">
                        <v-row class="ma-1" align="center" :class="!active ? '': 'grey lighten-1'">
                          <v-col
                            cols="12"
                            sm="4" md="2" lg="2"
                            class="text-left item-name"
                            @click="toggle" @keydown.space="toggle"
                            tabindex=14
                          >
                            <v-row align="center">
                              <v-col cols="2" align="center"><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon></v-col>
                              <v-col cols="10" align="left"><span>受付番号</span></v-col>
                            </v-row>
                          </v-col>
                          <v-col class="pb-1">
                            <v-row class="mb-0">
                              <v-col class="py-1">
                                <v-text-field
                                  v-model="rcpNo2Com"
                                  outlined
                                  hide-details
                                  dense
                                  :tabindex="selected.indexOf(3) == -1 ? 15 : -1"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-alert dence text type="error" v-show="rcpNo2ErrMsg" class="pa-1 mt-1 mb-0">{{ rcpNo2ErrMsg }}</v-alert>
                          </v-col>
                        </v-row>
                      </v-item>
                    </v-col>
                  </v-row>
                  <v-divider class="my-2"></v-divider>
                  <!-- 確認年度、番号 項目 -->
                  <v-row>
                    <v-col cols="12" class="py-0 pr-lg-0 pr-md-0" sm="12" md="6" lg="6">
                      <v-item v-slot="{ active, toggle }">
                        <v-row class="ma-1" align="center" :class="!active ? '': 'grey lighten-1'">
                          <v-col
                            cols="12"
                            sm="4" md="4" lg="4"
                            class="text-left item-name"
                            @click="toggle" @keydown.space="toggle"
                            tabindex=16
                          >
                            <v-row align="center">
                              <v-col cols="2" align="center"><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon></v-col>
                              <v-col cols="10" align="left"><span>確認年度</span></v-col>
                            </v-row>
                          </v-col>
                          <v-col>
                            <v-row class="py-0">
                              <v-col cols="12" sm="6" md="6" lg="6" align-self="center" class="py-1">
                                <v-select
                                  :items="eraList"
                                  item-text="era"
                                  :background-color="!active ? '': 'grey lighten-1'"
                                  @change="cnfYearSelected()"
                                  v-model="cnfEra"
                                  hide-details
                                  label="元号"
                                  solo dense
                                  :tabindex="selected.indexOf(4) == -1 ? 17 : -1"
                                ></v-select>
                              </v-col>
                              <v-col cols="12" sm="6" md="6" lg="6" class="py-1">
                                <v-combobox
                                  :items="cnfYearItems"
                                  item-text="fiscalYear"
                                  :background-color="!active ? '': 'grey lighten-1'"
                                  v-model="cnfYearYear"
                                  solo dense
                                  hide-details
                                  no-data-text="選択可能なデータはありません。"
                                  :tabindex="selected.indexOf(4) == -1 ? 18 : -1"
                                ></v-combobox>
                              </v-col>
                            </v-row>
                            <v-alert dence text type="error" v-show="cnfYearErrMsg" class="pa-1 mt-3 mb-0">{{ cnfYearErrMsg }}</v-alert>
                            <v-alert :class="selected.indexOf(4) == -1 ? 'white' : 'grey lighten-1'" class="mt-3 mb-0" v-show="!cnfYearErrMsg && cnfNo1ErrMsg"></v-alert>
                          </v-col>
                        </v-row>
                      </v-item>
                    </v-col>
                    <v-divider vertical class="my-1" v-show="['md','lg'].includes($vuetify.breakpoint.name)"></v-divider>
                    <v-col cols="12" class="py-0 pl-lg-0 pl-md-0" sm="12" md="6" lg="6">
                      <v-item v-slot="{ active, toggle }">
                        <v-row class="ma-1" align="center" :class="!active ? '': 'grey lighten-1'">
                          <v-col
                            cols="12"
                            sm="4" md="4" lg="3"
                            class="pa-2 text-left item-name"
                            @click="toggle" @keydown.space="toggle"
                            tabindex=19
                          >
                            <v-row align="center">
                              <v-col cols="2" align="center"><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon></v-col>
                              <v-col cols="10" align="left"><span>番号</span></v-col>
                            </v-row>
                          </v-col>
                          <v-col>
                            <v-row>
                              <v-col class="py-1">
                                <v-text-field
                                  id="cnfNum"
                                  ref="cnfNum"
                                  type="tel"
                                  placeholder="1~99999で入力してください。"
                                  v-model="cnfNo1Com"
                                  outlined
                                  hide-details
                                  hide-spin-buttons
                                  min="1"
                                  max="99999"
                                  dense
                                  :tabindex="selected.indexOf(5) == -1 ? 20 : -1"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-alert dence text type="error" v-show="cnfNo1ErrMsg" class="pa-1 mt-3 mb-0">{{ cnfNo1ErrMsg }}</v-alert>
                            <v-alert :class="selected.indexOf(5) == -1 ? 'white' : 'grey lighten-1'" class="mt-3 mb-0" v-show="cnfYearErrMsg && !cnfNo1ErrMsg"></v-alert>
                          </v-col>
                        </v-row>
                      </v-item>
                    </v-col>
                  </v-row>
                  <v-divider class="my-2"></v-divider>
                  <!-- 確認年月日 -->
                  <v-row class="py-0">
                    <v-col class="py-0">
                      <v-item v-slot="{ active, toggle }">
                        <v-row class="ma-1" align="center" :class="!active ? '': 'grey lighten-1'">
                          <v-col
                            cols="12"
                            sm="4" md="2" lg="2"
                            class="text-left item-name"
                            @click="toggle" @keydown.space="toggle"
                            tabindex=21
                          >
                            <v-row align="center">
                              <v-col cols="2" align="center"><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon></v-col>
                              <v-col cols="10" align="left"><span>確認年月日</span></v-col>
                            </v-row>
                          </v-col>
                          <v-col class="py-0">
                            <v-row align="center" class="ma-1">
                              <v-col cols="12" sm="5" md="5" lg="5" class="py-0 pl-0">
                                <DatePicker
                                  ref="cnfStartDate" v-model="cnfStart" @clear="cnfStart = $event"
                                  :tabIdx="selected.indexOf(6) == -1 ? 22 : -2" :active="active"/>
                              </v-col>
                              <v-col cols="12" sm="2" md="1" lg="1" class="text-center py-2 pl-0" justify="center">～</v-col>
                              <v-col cols="12" sm="5" md="5" lg="5" class="py-0 pl-0">
                                <DatePicker
                                  ref="cnfEndDate" v-model="cnfEnd" @clear="cnfEnd = $event"
                                  :tabIdx="selected.indexOf(6) == -1 ? 23 : -2" :active="active"/>
                              </v-col>
                            </v-row>
                            <v-alert dence text type="error" v-show="cnfDateErrMsg" class="pa-1 mt-1 mb-0">{{ cnfDateErrMsg }}</v-alert>
                          </v-col>
                        </v-row>
                      </v-item>
                    </v-col>
                  </v-row>
                  <v-divider class="my-2"></v-divider>
                  <!-- 確認番号 -->
                  <v-row>
                    <v-col class="py-0">
                      <v-item v-slot="{ active, toggle }">
                        <v-row class="ma-1" align="center" :class="!active ? '': 'grey lighten-1'">
                          <v-col cols="12" sm="4" md="2" lg="2" class="text-left item-name" @click="toggle" @keydown.space="toggle" tabindex="24">
                            <v-row align="center">
                              <v-col cols="2" align="center"><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon></v-col>
                              <v-col cols="10" align="left"><span>確認番号</span></v-col>
                            </v-row>
                          </v-col>
                          <v-col class="pb-1">
                            <v-row class="mb-0">
                              <v-col class="py-1">
                                <v-text-field
                                  v-model="cnfNo2Com"
                                  outlined
                                  hide-details
                                  dense
                                  :tabindex="selected.indexOf(7) == -1 ? 25 : -1"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-alert dence text type="error" v-show="cnfNo2ErrMsg" class="pa-1 mt-1 mb-0">{{ cnfNo2ErrMsg }}</v-alert>
                          </v-col>
                        </v-row>
                      </v-item>
                    </v-col>
                  </v-row>
                  <v-divider class="my-2"></v-divider>
                  <!-- 地名地番 -->
                  <v-row>
                    <v-col class="py-0">
                      <v-item v-slot="{ active, toggle }">
                        <v-row class="ma-1" align="center" :class="!active ? '': 'grey lighten-1'">
                          <v-col
                            cols="12"
                            sm="4" md="2" lg="2"
                            class="text-left item-name"
                            @click="toggle" @keydown.space="toggle"
                            tabindex=26>
                            <v-row align="center">
                              <v-col cols="2" align="center"><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon></v-col>
                              <v-col cols="10" align="left"><span>地名地番</span></v-col>
                            </v-row>
                          </v-col>
                          <v-col class="pb-1">
                            <v-row class="mb-0">
                              <v-col cols="12" sm="12" md="6" lg="4" align-self="center" class="py-1">
                                <v-select
                                  :items="wardList"
                                  item-text="name"
                                  :background-color="!active ? '': 'grey lighten-1'"
                                  v-model="placeLotNoWard"
                                  hide-details
                                  solo dense
                                  placeholder="区名"
                                  :tabindex="selected.indexOf(8) == -1 ? 27 : -1"
                                ></v-select>
                              </v-col>
                              <v-col cols="12" sm="12" md="6" lg="4" class="py-1">
                                <v-combobox
                                  :items="townList"
                                  item-text="name"
                                  :background-color="!active ? '': 'grey lighten-1'"
                                  v-model="placeLotNoTown"
                                  solo dense
                                  hide-details
                                  no-data-text="選択できるデータはありません。"
                                  placeholder="町名"
                                  :tabindex="selected.indexOf(8) == -1 ? 28 : -1"
                                ></v-combobox>
                              </v-col>
                              <v-col cols="12" sm="12" md="12" lg="4" class="py-1">
                                <v-text-field
                                  v-model="placeLotNoAddr"
                                  :background-color="!active ? '': 'grey lighten-1'"
                                  solo dense
                                  hide-details
                                  placeholder="番地"
                                  :tabindex="selected.indexOf(8) == -1 ? 29 : -1"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-alert dence text type="error" v-show="placeLotNoErrMsg" class="pa-1 mt-3 mb-0">{{ placeLotNoErrMsg }}</v-alert>
                          </v-col>
                        </v-row>
                      </v-item>
                    </v-col>
                  </v-row>
                  <v-divider class="my-2"></v-divider>
                  <!-- 当初代表建築主 -->
                  <v-row>
                    <v-col class="py-0">
                      <v-item v-slot="{ active, toggle }">
                        <v-row class="ma-1" align="center" :class="!active ? '': 'grey lighten-1'">
                          <v-col
                            cols="12"
                            sm="4" md="2" lg="2"
                            class="text-left item-name"
                            @click="toggle" @keydown.space="toggle"
                            tabindex=30>
                            <v-row align="center">
                              <v-col cols="2" align="center"><v-icon>{{!active ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon></v-col>
                              <v-col cols="10" align="left"><span>当初代表<br v-show="['md','lg'].includes($vuetify.breakpoint.name)"/>建築主氏名</span></v-col>
                            </v-row>
                          </v-col>
                          <v-col class="pb-1">
                            <v-row class="mb-0">
                              <v-col class="py-1">
                                <v-text-field
                                  v-model="initRepArchitectCom"
                                  outlined
                                  hide-details
                                  dense
                                  :tabindex="selected.indexOf(9) == -1 ? 31 : -1"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-alert dence text type="error" v-show="initRepArchitectErrMsg" class="pa-1 mt-1 mb-0">{{ initRepArchitectErrMsg }}</v-alert>
                          </v-col>
                        </v-row>
                      </v-item>
                    </v-col>
                  </v-row>
                  <v-divider class="my-2" ></v-divider>
                  <!-- 検索 -->
                  <v-row class="mx-1  my-0">
                    <v-col class="py-0" :class="['xs','sm'].includes($vuetify.breakpoint.name) ? 'px-0' : ''">
                      <v-row class="ma-1">
                        <v-spacer></v-spacer>
                        <v-col cols="12" sm="12" md="3" lg="3" align="center" class="py-0" :class="['xs','sm'].includes($vuetify.breakpoint.name) ? 'px-0' : ''">
                          <v-btn
                            color="primary"
                            large
                            block
                            @click="search()"
                            :disabled="serchEnable"
                            tabindex="32"
                          >
                            検索
                          </v-btn>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3" align="center" class="py-0" :class="['xs','sm'].includes($vuetify.breakpoint.name) ? 'mt-4 px-0' : ''">
                          <v-btn
                            color="grey lighten-1"
                            large
                            block
                            @click="searchClear()"
                            tabindex="33"
                          >
                            全ての検索条件をクリア
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-item-group>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <Dialog error :open="authDialog" :ok="()=>authDialog=false" :to="'/'"
      :title="'ユーザー認証'" :body="'ユーザー認証に失敗しました。ログインし直して下さい。'"/>
    <!-- 検索中ダイアログ -->
    <v-dialog id="searchlodingDialog" width="30%" v-model="searchDialog" persistent>
      <v-card>
        <v-card-title class="text-h6 px-5">
          <v-icon large color="primary">mdi-database-search</v-icon>&nbsp;検索中
        </v-card-title>
        <v-card-text class="pb-0">
          <v-progress-linear
            color="light-blue darken-2"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="cancelSearch()">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- メッセージダイアログ -->
    <v-dialog id="dialog" width="30%" v-model="dialog" persistent>
      <v-card>
        <v-card-title>検索</v-card-title>
        <v-card-text class="pa-0">
          <v-row align="center" class="ma-1">
            <v-col cols="2" class="pa-0" align="center">
              <v-icon large color="error" class="ma-auto" v-if="dialogCategory == 1">mdi-alert</v-icon>
              <v-icon large color="success" class="ma-auto" v-else-if="dialogCategory == 0">mdi-check-circle</v-icon>
            </v-col>
            <v-col cols="10">{{ dialogMsg }}</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-1">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
//import { dbglog } from '../common/utils.js'
import DatePicker from '../components/DatePicker.vue'
import Dialog from '../components/Dialog.vue'
import Constants from '../common/constants'
import { /*searchAttr,*/ callPostApi, callGetApi } from '../common/apiAccess'
import { apiUrl, getWardCode } from '../common/utils'

export default {
  components: {
    DatePicker,
    Dialog
  },
  data() {
    return {
      bango: '',
      nendo: '',
      selected: [], // 検索対象有無判定配列 
      snsShubetsu: '', // 申請種別
      snsKubun: [], // 申請区分
      ippanKeikaku: [], // 一般計画
      rcpYear: {era: '', year: null}, // 受付年度
      rcpYearItems: [], // 受付年度選択制御用変数
      rcpNo1: null, // 番号(受付)
      rcpStartDate: '', // 受付年月日の開始日
      rcpEndDate: '', // 受付年月日の終了日
      rcpNo2: '', // 受付番号
      cnfYear: {era: '', year: null}, // 確認年度
      cnfYearItems: [], // 確認年度選択制御用変数
      cnfNo1: null, // 番号(確認)
      cnfStartDate: '', // 確認年月日の開始日
      cnfEndDate: '', // 確認年月日の終了日
      cnfNo2: '', // 確認番号
      wardList: Constants.Wards,
      townList:[],
      placeLotNo: {ward: '',town: '',address: ''}, // 地名地番
      initRepArchitect: '', // 当初代表建築主
      serchEnable: true, // 検索ボタン状態制御
      eraList: [],
      // バリデーション
      valid: true,
      rcpYearErrMsg: '',
      rcpNo1ErrMsg: '',
      rcpDateErrMsg: '',
      rcpNo2ErrMsg: '',
      cnfYearErrMsg: '',
      cnfNo1ErrMsg: '',
      cnfDateErrMsg: '',
      cnfNo2ErrMsg: '',
      placeLotNoErrMsg: '',
      initRepArchitectErrMsg:'',
      // 検索中フラグ
      searching: false,
      searchDialog: false,
      dialog: false,
      dialogCategory: 0, // 0:正常(success),1:異常(error)
      dialogMsg: '',
      // API中断用コントローラ
      controller: null,
      // メッセージダイアログ
      authDialog: false,
    }
  },
  mounted () {
    if (this.unauthorized) {
      this.authDialog = true;
    }
    this.$store.commit('setCurrentPage', 3);
    this.init();
    this.message = '検索条件を指定してください';
    document.getElementById('kenchiku').focus();
    this.$store.commit('setListAttrData', null);
  },
  updated() {
    // 受付年度
    if(this.selected.indexOf(0) == -1){
      this.rcpYearErrMsg = this.requiredValid(this.rcpYear.year,'受付年度');
      let regex = new RegExp(/[0-9]+$/);
      if(!regex.test(this.rcpYear.year)){
        this.rcpYearErrMsg = '半角数字のみ入力してください。';
      }else{
        this.rcpYearErrMsg = this.checkValueRange(this.rcpYearItems[this.rcpYearItems.length-1],this.rcpYearItems[0],parseInt(this.rcpYear.year));
      }
      this.searchBtnControll();
    }else{
      this.rcpYearErrMsg = '';
      this.searchBtnControll();
    }

    // 受付番号1
    if(this.selected.indexOf(1) == -1){
      this.rcpNo1ErrMsg = this.requiredValid(this.rcpNo1,'番号');
      this.searchBtnControll();
    }else{
      this.rcpNo1ErrMsg = '';
      this.searchBtnControll();
    }

    // 受付年月日
    if(this.selected.indexOf(2) == -1){
      this.rcpDateErrMsg = this.dateValid(this.rcpStartDate,this.rcpEndDate,'受付');
      this.searchBtnControll();
    }else{
      this.rcpDateErrMsg = '';
      this.searchBtnControll();
    }

    // 受付番号2
    if(this.selected.indexOf(3) == -1){
      this.rcpNo2ErrMsg = this.requiredValid(this.rcpNo2,'受付番号');
      this.searchBtnControll();
    }else{
      this.rcpNo2ErrMsg = '';
      this.searchBtnControll();
    }

    // 確認年度
    if(this.selected.indexOf(4) == -1){
      this.cnfYearErrMsg = this.requiredValid(this.cnfYear.year,'確認年度');
      let regex = new RegExp(/[0-9]+$/);
      if(!regex.test(this.cnfYear.year)){
        this.cnfYearErrMsg = '半角数字のみ入力してください。';
      }else{
        this.cnfYearErrMsg = this.checkValueRange(this.cnfYearItems[this.cnfYearItems.length-1],this.cnfYearItems[0],parseInt(this.cnfYear.year));
      }
      this.searchBtnControll();
    }else{
      this.cnfYearErrMsg = '';
      this.searchBtnControll();
    }

    // 確認番号1
    if(this.selected.indexOf(5) == -1){
      this.cnfNo1ErrMsg = this.requiredValid(this.cnfNo1,'番号');
      this.searchBtnControll();
    }else{
      this.cnfNo1ErrMsg = '';
      this.searchBtnControll();
    }

    // 確認年月日
    if(this.selected.indexOf(6) == -1){
      this.cnfDateErrMsg = this.dateValid(this.cnfStartDate,this.cnfEndDate,'確認');
      this.searchBtnControll();
    }else{
      this.cnfDateErrMsg = '';
      this.searchBtnControll();
    }

    // 確認番号2
    if(this.selected.indexOf(7) == -1){
      this.cnfNo2ErrMsg = this.requiredValid(this.cnfNo2,'確認番号');
      this.searchBtnControll();
    }else{
      this.cnfNo2ErrMsg = '';
      this.searchBtnControll();
    }

    // 地名地番
    if(this.selected.indexOf(8) == -1){
      this.placeLotNoErrMsg = this.requiredValid(this.placeLotNo.ward + this.placeLotNo.town + this.placeLotNo.address,'地名地番');
      this.searchBtnControll();
    }else{
      this.placeLotNoErrMsg = '';
      this.searchBtnControll();
    }

    // 当初代表建築主氏名
    if(this.selected.indexOf(9) == -1){
      this.initRepArchitectErrMsg = this.requiredValid(this.initRepArchitect,'当初代表建築主氏名');
      this.searchBtnControll();
    }else{
      this.initRepArchitectErrMsg = '';
      this.searchBtnControll();
    }
  },
  // 詳細検索画面からメニュー画面に戻る際の処理
  beforeRouteLeave(to, from, next) {
		if(to.name === 'method'){
			this.$store.commit('setSearchAttrCond', null);
			next();
		}else{
			next();
		}
	},
  computed: {
    mode: {
      get() { return this.$store.state.mode; },
      set(val) { this.$store.commit('setMode', val); }
    },
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    headMessage () {
      return "詳細検索";
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    rcpYearEra: {
      get() { return this.rcpYear.era },
      set(val) {
        if(this.selected.indexOf(0) == -1){
          this.rcpYearErrMsg = this.requiredValid(val,'受付年度');
          this.searchBtnControll();
        }
        return this.rcpYear.era = val;
      },
    },
    rcpYearYear: {
      get() { return this.rcpYear.year; },
      set(val) {
        if(this.selected.indexOf(0) == -1){
          this.rcpYearErrMsg = this.requiredValid(val,'年度');
          let regex = new RegExp(/[0-9]+$/);
          if(!regex.test(val)){
            this.rcpYearErrMsg = '半角数字のみ入力してください。';
          }else{
            this.rcpYearErrMsg = this.checkValueRange(this.rcpYearItems[this.rcpYearItems.length-1],this.rcpYearItems[0],parseInt(val));
          }
          this.searchBtnControll();
        }
        return this.rcpYear.year = val;
      }
    },
    rcpNo1Com: {
      get() {return this.rcpNo1; },
      set(val) {
        if(this.selected.indexOf(1) == -1){
          this.rcpNo1ErrMsg = this.requiredValid(val,'番号');
          this.searchBtnControll();
        }
        const min = Number(this.$refs.rcpNum.$attrs.min);
        const max = Number(this.$refs.rcpNum.$attrs.max);
        val = parseInt(val);
        if(Number.isNaN(val) || val < min){
          val = '';
        }else if(val > max){
          val = max;
        }
        this.$refs.rcpNum.lazyValue = val;
        return this.rcpNo1 = val;
      }
    },
    rcpStart: {
      get() { return this.rcpStartDate; },
      set(val) {
        if(this.selected.indexOf(2) == -1){
          this.rcpDateErrMsg = this.dateValid(val,this.rcpEndDate,'受付');
          this.searchBtnControll();
        }
        this.$refs.rcpStartDate.pickerText = val;
        return this.rcpStartDate = val;
      }
    },
    rcpEnd: {
      get() { return this.rcpEndDate; },
      set(val) {
        if(this.selected.indexOf(2) == -1){
          this.rcpDateErrMsg = this.dateValid(this.rcpStartDate,val,'受付');
          this.searchBtnControll();
        }
        this.$refs.rcpEndDate.pickerText = val;
        return this.rcpEndDate = val;
      }
    },
    rcpNo2Com: {
      get() { return this.rcpNo2; },
      set(val) {
        if(this.selected.indexOf(3) == -1){
          this.rcpNo2ErrMsg = this.requiredValid(val,'受付番号');
          this.searchBtnControll();
        }
        return this.rcpNo2 = val;
      }
    },
    cnfEra: {
      get() { return this.cnfYear.era },
      set(val) {
        if(this.selected.indexOf(4) == -1){
          this.cnfYearErrMsg = this.requiredValid(val,'確認年度');
          this.searchBtnControll();
        }
        return this.cnfYear.era = val;
      }
    },
    cnfYearYear: {
      get() { return this.cnfYear.year; },
      set(val) {
        if(this.selected.indexOf(0) == -1){
          this.cnfYearErrMsg = this.requiredValid(val,'年度');
          let regex = new RegExp(/[0-9]+$/);
          if(!regex.test(val)){
            this.cnfYearErrMsg = '半角数字のみ入力してください。';
          }else{
            this.cnfYearErrMsg = this.checkValueRange(this.cnfYearItems[this.cnfYearItems.length-1],this.cnfYearItems[0],parseInt(val));
          }
          this.searchBtnControll();
        }
        return this.cnfYear.year = val;
      }
    },
    cnfNo1Com: {
      get() { return this.cnfNo1 },
      set(val) {
        if(this.selected.indexOf(5) == -1){
          this.cnfNo1ErrMsg = this.requiredValid(val,'番号');
          this.searchBtnControll();
        }
        const min = Number(this.$refs.cnfNum.$attrs.min);
        const max = Number(this.$refs.cnfNum.$attrs.max);
        val = parseInt(val);
        if(Number.isNaN(val) || val < min){
          val = '';
        }else if(val > max){
          val = max;
        }
        this.$refs.cnfNum.lazyValue = val;
        return this.cnfNo1 = val;
      }
    },
    cnfStart: {
      get() { return this.cnfStartDate; },
      set(val) {
        if(this.selected.indexOf(6) == -1){
          this.cnfDateErrMsg = this.dateValid(val,this.cnfEndDate,'確認');
          this.searchBtnControll();
        }
        this.$refs.cnfStartDate.pickerText = val;
        return this.cnfStartDate = val;
      }
    },
    cnfEnd: {
      get() { return this.cnfEndDate; },
      set(val) {
        if(this.selected.indexOf(6) == -1){
          this.cnfDateErrMsg = this.dateValid(this.cnfStartDate,val,'確認');
          this.searchBtnControll();
        }
        this.$refs.cnfEndDate.pickerText = val;
        return this.cnfEndDate = val;
      }
    },
    cnfNo2Com:{
      get() { return this.cnfNo2 },
      set(val) {
        if(this.selected.indexOf(7) == -1){
          this.cnfNo2ErrMsg = this.requiredValid(val,'確認番号');
          this.searchBtnControll();
        }
        return this.cnfNo2 = val;
      }
    },
    placeLotNoWard: {
      get() { return this.placeLotNo.ward },
      set(val) {
        if(this.selected.indexOf(8) == -1){
          this.placeLotNoErrMsg = this.requiredValid(val + this.placeLotNo.town + this.placeLotNo.address,'地名地番');
          this.searchBtnControll();
        }
        this.loadTowns(val);
        this.placeLotNoTown = { name: '' };
        return this.placeLotNo.ward = val;
      }
    },
    placeLotNoTown: {
      get() { return this.placeLotNo.town },
      set(val) {
        if(this.selected.indexOf(8) == -1){
          this.placeLotNoErrMsg = this.requiredValid(this.placeLotNo.ward + val.name + this.placeLotNo.address,'地名地番');
          this.searchBtnControll();
        }
        return this.placeLotNo.town = val.name;
      }
    },
    placeLotNoAddr: {
      get() { return this.placeLotNo.address },
      set(val) {
        if(this.selected.indexOf(8) == -1){
          this.placeLotNoErrMsg = this.requiredValid(this.placeLotNo.ward + this.placeLotNo.town + val,'地名地番');
          this.searchBtnControll();
        }
        return this.placeLotNo.address = val;
      }
    },
    initRepArchitectCom: {
      get() { return this.initRepArchitect },
      set(val) {
        if(this.selected.indexOf(9) == -1){
          this.initRepArchitectErrMsg = this.requiredValid(val,'当初代表建築主氏名');
          this.searchBtnControll();
        }
        return this.initRepArchitect = val;
      }
    }
  },
  methods: {
    loadTowns(wardName) {
      const wardCode = getWardCode(wardName);
      const url = apiUrl('Towns') + '?ward=' + wardCode;
      callGetApi(url, (data) => {
        if (data.errorDesc !== undefined) {
          console.log(data.errorDesc);
        }
        else {
          this.townList = data;
        }
      });
    },
    cancelSearch() {
      this.controller.abort();
      this.searchDialog = false;
      this.dialogCategory = 0;
      this.dialog = true;
      this.dialogMsg = 'キャンセルされました。';
    },
    search() {
      if(this.$refs.form.validate()){
        this.searchConditionSet();
        callPostApi(apiUrl('AttrSearchCount'),
                    this.$store.state.searchAttrCond, (data) => {
          if (data == 0) {
            this.dialog = true;
            this.dialogCategory = 1;
            this.dialogMsg = '検索条件に一致するデータが見つかりません。';
          }
          else if (data >= 10000) {
            this.dialog = true;
            this.dialogCategory = 1;
            this.dialogMsg = `検索条件に一致するデータが ${data} 件あります。条件を絞り込んで下さい。`;
          }else if(data.errorCode == 401){
            this.authDialog = true;
          }else if (data.errorDesc !== undefined) {
            this.dialog = true;
            this.dialogCategory = 1;
            this.dialogMsg = `エラーが発生しました: ${data.errorDesc}`;
          }else {
            this.searchDialog = true;
            this.controller = callPostApi(apiUrl('AttrSearch'),
                    this.$store.state.searchAttrCond, (data) => {
              this.searchDialog = false;
              if (data.errorDesc !== undefined) {
                this.dialog = true;
                this.dialogCategory = 1;
                this.dialogMsg = `エラーが発生しました: ${data.errorDesc}`;
              }
              else if (data !== null && data.length !== undefined) {
                this.$store.commit('setAttrList', data);
                this.$router.push('listattr');
              }
              else {
                console.log(`SearchAttr.search(): returns ${data}`);
              }
            });
          }
        });
      }
    },
    init() {
      // セレクトボックスデータの準備
      this.eraList.push({era: '',yearData: []});
      const def = Constants.warekiDef;
      for(let i = 0; i < def.length; i++){
        if(!(def[i].era == '明治' || def[i].era == '大正' || def[i].era == '')){
          const tempArr = [];
          for(let j = 0; j < (def[i].lastNendo - def[i].startNendo + 1); j++){
            tempArr.push(
              // {
              // fiscalYear: def[i].lastNendo - j,
              // year: def[i].firstYear + def[i].lastNendo - j - 1
              def[i].lastNendo - j
              // }
            );
          }
          this.eraList.push({
            era: def[i].era,
            yearData:tempArr
          });
        }
      }
      if(this.$store.state.searchAttrCond == null){
        // 必須項目のデフォルト値設定
        this.snsShubetsu = 0;
        this.snsKubun = [0,1];
        this.ippanKeikaku = [0,1];
        // 初期は検索対象はずす
        this.selected = [0,1,2,3,4,5,6,7,8,9];
        
      }else{
        // stateに保存してある検索条件をセット
        this.snsShubetsu = this.$store.state.searchAttrCond.snsShubetsu;
        this.snsKubun = this.$store.state.searchAttrCond.snsKubun;
        this.ippanKeikaku = this.$store.state.searchAttrCond.ippanKeikaku;
        this.rcpYear = this.$store.state.searchAttrCond.rcpYear;
        for(let i = 0; i < this.eraList.length; i++){
          if(this.eraList[i].era == this.rcpYear.era){
            this.rcpYearItems = this.eraList[i].yearData;
          }
        }
        this.rcpNo1 = this.$store.state.searchAttrCond.rcpNo1;
        this.rcpStart = this.$store.state.searchAttrCond.rcpStartDate;
        this.$refs.rcpStartDate.picker = this.$store.state.searchAttrCond.rcpStartDate;
        this.rcpEnd = this.$store.state.searchAttrCond.rcpEndDate;
        this.$refs.rcpEndDate.picker = this.$store.state.searchAttrCond.rcpEndDate;
        this.rcpNo2 = this.$store.state.searchAttrCond.rcpNo2;
        this.cnfYear = this.$store.state.searchAttrCond.cnfYear;
        for(let i = 0; i < this.eraList.length; i++){
          if(this.eraList[i].era == this.cnfYear.era){
            this.cnfYearItems = this.eraList[i].yearData;
          }
        }
        this.cnfNo1 = this.$store.state.searchAttrCond.cnfNo1;
        this.cnfStart = this.$store.state.searchAttrCond.cnfStartDate;
        this.$refs.cnfStartDate.picker = this.$store.state.searchAttrCond.cnfStartDate;
        this.cnfEnd = this.$store.state.searchAttrCond.cnfEndDate;
        this.$refs.cnfEndDate.picker = this.$store.state.searchAttrCond.cnfEndDate;
        this.cnfNo2 = this.$store.state.searchAttrCond.cnfNo2;
        this.placeLotNo.ward = this.$store.state.searchAttrCond.placeLotNo.ward;
        this.placeLotNo.town = this.$store.state.searchAttrCond.placeLotNo.town;
        this.townList = this.loadTowns(this.placeLotNo.ward);
        this.placeLotNo.address = this.$store.state.searchAttrCond.placeLotNo.address;
        this.initRepArchitect = this.$store.state.searchAttrCond.initRepArchitect;
        this.selected = this.$store.state.searchAttrCond.selected;
      }
    },
    // 検索条件保持用関数
    searchConditionSet(){
      let condition = {
        snsShubetsu: this.snsShubetsu,
        snsKubun: this.snsKubun,
        ippanKeikaku: this.ippanKeikaku,
        rcpYear:{era: this.rcpYear.era, year: this.rcpYear.year},
        rcpNo1: this.rcpNo1,
        rcpStartDate: this.rcpStartDate,
        rcpEndDate: this.rcpEndDate,
        rcpNo2: this.rcpNo2,
        cnfYear: {era: this.cnfYear.era, year: this.cnfYear.year},
        cnfNo1: this.cnfNo1,
        cnfStartDate: this.cnfStartDate,
        cnfEndDate: this.cnfEndDate,
        cnfNo2: this.cnfNo2,
        placeLotNo: {ward: this.placeLotNo.ward,town: this.placeLotNo.town, address: this.placeLotNo.address},
        initRepArchitect: this.initRepArchitect,
        selected: this.selected
      };
      this.$store.commit('setSearchAttrCond',condition);
    },
    // 「全ての検索条件をクリア」ボタン押下時のイベント
    searchClear() {
      // 全ての値を初期化
      this.$refs.rcpStartDate.picker = '';
      this.$refs.rcpStartDate.pickerText = '';
      this.$refs.rcpEndDate.picker = '';
      this.$refs.rcpEndDate.pickerText = '';
      this.$refs.cnfStartDate.picker = '';
      this.$refs.cnfStartDate.pickerText = '';
      this.$refs.cnfEndDate.picker = '';
      this.$refs.cnfEndDate.pickerText = '';
      this.selected = [0,1,2,3,4,5,6,7,8,9];
      this.snsShubetsu = 0;
      this.snsKubun = [0,1];
      this.ippanKeikaku = [0,1];
      this.rcpYear = {era: '', year: null};
      this.rcpNo1 = null;
      this.rcpStartDate = null;
      this.rcpEndDate = null;
      this.rcpNo2 = null;
      this.cnfYear = {era: '', year: null};
      this.cnfNo1 = null;
      this.cnfStartDate = null;
      this.cnfEndDate = null;
      this.cnfNo2 = null;
      this.placeLotNo = {ward: '', town: ''};
      this.initRepArchitect = '';
      this.rcpDateErrMsg = '';
      this.cnfDateErrMsg = '';
    },
    /**
     * 受付年度入力の際、指定された元号によって入力アイテムが変わる処理 
     * 元号指定が変わった場合、選択済みの値は破棄される。
    */
    rcpYearSelected() {
      this.rcpYear.year = null;
      for(let i = 0; i < this.eraList.length; i++){
        if(this.eraList[i].era == this.rcpYear.era){
          this.rcpYearItems = this.eraList[i].yearData;
        }
      }
      if(this.rcpYearItems.length != 0){
        this.rcpYear.year = this.rcpYearItems[0];
      }
    },
    /**
     * 確認年度入力の際、指定された元号によって入力アイテムが変わる処理 
     * 元号指定が変わった場合、選択済みの値は破棄される。
    */
    cnfYearSelected() {
      this.cnfYear.year = null;
      for(let i = 0; i < this.eraList.length; i++){
        if(this.eraList[i].era == this.cnfYear.era){
          this.cnfYearItems = this.eraList[i].yearData;
        }
      }
      if(this.cnfYearItems.length != 0){
        this.cnfYear.year = this.cnfYearItems[0];
      }
    },
    // 検索ボタンの有効化
    searchBtnControll(){
      if(this.rcpYearErrMsg || this.rcpNo1ErrMsg || this.rcpDateErrMsg || this.rcpNo2ErrMsg ||
      this.cnfYearErrMsg || this.cnfNo1ErrMsg || this.cnfDateErrMsg || this.cnfNo2ErrMsg || this.placeLotNoErrMsg || this.initRepArchitectErrMsg || this.selected.length == 10){
        this.serchEnable = true;
      }else{
        this.serchEnable = false;
      }
    },
    // バリデーション群
    /**
     * 必須チェック
     * arg:
     *     value1: 比較対象1(必須)
     *     name1: 項目名
     * return: name1 を入力してください。
     * explanation: 空白 or nullをチェックする
     * */
    requiredValid(value1,name1) {
      if(value1 == '' || value1 === null){
        return name1 + 'を入力してください。';
      }
    },
    /**
     * 年月日チェック
     * arg:
     *     value1: 開始日
     *     value2: 終了日
     *     name: 項目名
     */
    dateValid(value1,value2,name) {
      if(value1 == '' && value2 == ''){
        return name + '年月日を入力してください。';
      }else if(value1 != '' && value2 != ''){
        let date1 = new Date(value1);
        let date2 = new Date(value2);
        if(date1.valueOf() > date2.valueOf()){
          return name + '開始日は' + name +'終了日以前の日付を入力してください。';
        }else{
          return '';
        }
      }else{
        return '';
      }
    },
    /**
     * 入力値範囲チェック(数値)
     * arg:
     *     min: 最小値 Number
     *     max: 最大値 Number
     *     value: 比較対象 Number
     * return: min～maxを入力してください。
     */
    checkValueRange(min,max,value) {
      if(min > value || max < value){
        return min + '～' + max + 'で入力してください。';
      }
      return '';
    }
  }
}
</script>
<style lang="scss" scoped>
.item-name {
  font-size: 16px;
  font-weight: 800;
}

.v-alert {
  font-size: 16px !important;
}

.v-input{
	font-size: 16px !important;
}

.v-text-field input{
	font-size: 16px !important;
}

button {
  font-size: 16px !important;
}
</style>